import { render, staticRenderFns } from "./CustomEmailModels.vue?vue&type=template&id=0b9dedda"
import script from "./CustomEmailModels.vue?vue&type=script&lang=js"
export * from "./CustomEmailModels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports